import React from 'react'

const C_inh = () => {
    return (
        <div className='container'>
            <h1>Difference between Inheritance and Polymorphism</h1>
            <p><b>Inheritance:</b><br/>
            Inheritance is one in which a new class is created that inherits the properties of the already exist class.
             It supports the concept of code reusability and reduces the length of the code in object-oriented programming.</p>
             <p>Types of Inheritance are:</p>
             <ol><li>Single inheritance</li>
             <li>Multi-level inheritance</li>
             <li>Multiple inheritance</li>
             <li>Hybrid inheritance</li>
             <li>Hierarchical inheritance</li>
             </ol>
             <p><b>Example of Inheritance:</b><br/></p>
             <div class="containers">
        <div class="line number1 index0 alt2"><code class="library">#include "iostream"</code></div>
        <div class="line number2 index1 alt1"><code class="library">using</code> <code
                        class="library">namespace</code> <code class="plain">std;</code></div>
        <div class="line number3 index2 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number4 index3 alt1"><code class="library">class</code> <code class="plain">A &#123;</code>
        </div>
        <div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">int</code> <code class="plain">a, b;</code></div>
        <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number7 index6 alt2"><code class="library">public</code><code class="plain">:</code></div>
        <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">void</code> <code class="plain">add(</code><code
                        class="keywords">int</code> <code class="plain">x, </code><code
                        class="keywords">int</code> <code class="plain">y)</code></div>
        <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#123;</code></div>
        <div class="line number10 index9 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">a = x;</code></div>
        <div class="line number11 index10 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">b = y;</code></div>
        <div class="line number12 index11 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout &lt;&lt; (a + b) &lt;&lt; endl;</code></div>
        <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#125;</code></div>
        <div class="line number14 index13 alt1"><code class="plain">&#125;;</code></div>
        <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number16 index15 alt1"><code class="library">class</code> <code
                        class="plain">B : </code><code class="library">public</code> <code class="plain">A &#123;</code>
        </div>
        <div class="line number17 index16 alt2"><code class="library">public</code><code class="plain">:</code>
        </div>
        <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">void</code> <code class="plain">print(</code><code
                        class="keywords">int</code> <code class="plain">x, </code><code
                        class="keywords">int</code> <code class="plain">y)</code></div>
        <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#123;</code></div>
        <div class="line number20 index19 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">add(x, y);</code></div>
        <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#125;</code></div>
        <div class="line number22 index21 alt1"><code class="plain">&#125;;</code></div>
        <div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number24 index23 alt1"><code class="keywords">int</code> <code class="plain">main()</code>
        </div>
        <div class="line number25 index24 alt2"><code class="plain">&#123;</code></div>
        <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">B b1;</code></div>
        <div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">b1.print(5, 6);</code></div>
        <div class="line number28 index27 alt1"><code class="plain">&#125;</code></div>
</div>
<div>
<p><strong>Output:</strong></p>
addition of a+b is:11 
 </div>
 <p>Here, class B is the derived class which inherit the property(<b>add method</b>) of the base class A.</p>
 <p><strong>Polymorphism:</strong></p>
 <p><b>Polymorphism:</b><br/>
 Polymorphism is that in which we can perform a task in multiple forms or ways. It is applied to the functions or methods.
  Polymorphism allows the object to decide which form of the function to implement at compile-time as well as run-time.</p>
  <p>Types of Polymorphism are:</p>
  <ol><li>Compile-time polymorphism (Method overloading)</li>
  <li>Run-time polymorphism (Method Overriding)</li>
  </ol>
  <div class="containers">
        <div class="line number1 index0 alt2"><code class="library">#include "iostream"</code></div>
        <div class="line number2 index1 alt1"><code class="library">using</code> <code
                        class="library">namespace</code> <code class="plain">std;</code></div>
        <div class="line number3 index2 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number4 index3 alt1"><code class="library">class</code> <code class="plain">A &#123;</code>
        </div>
        <div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">int</code> <code class="plain">a, b, c;</code></div>
        <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number7 index6 alt2"><code class="library">public</code><code class="plain">:</code></div>
        <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">void</code> <code class="plain">add(</code><code
                        class="keywords">int</code> <code class="plain">x, </code><code
                        class="keywords">int</code> <code class="plain">y)</code></div>
        <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#123;</code></div>
        <div class="line number10 index9 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">a = x;</code></div>
        <div class="line number11 index10 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">b = y;</code></div>
        <div class="line number12 index11 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout &lt;&lt; </code><code class="string">"addition of a+b is:"</code> <code
                        class="plain">&lt;&lt; (a + b) &lt;&lt; endl;</code></div>
        <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#125;</code></div>
        <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">void</code> <code class="plain">add(</code><code
                        class="keywords">int</code> <code class="plain">x, </code><code
                        class="keywords">int</code> <code class="plain">y, </code><code
                        class="keywords">int</code> <code class="plain">z)</code></div>
        <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#123;</code></div>
        <div class="line number17 index16 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">a = x;</code></div>
        <div class="line number18 index17 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">b = y;</code></div>
        <div class="line number19 index18 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">c = z;</code></div>
        <div class="line number20 index19 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout &lt;&lt; </code><code class="string">"addition of a+b+c is:"</code> <code
                        class="plain">&lt;&lt; (a + b + c) &lt;&lt; endl;</code></div>
        <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#125;</code></div>
        <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">void</code> <code class="plain">print()</code></div>
        <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#123;</code></div>
        <div class="line number25 index24 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout &lt;&lt; </code><code class="string">"Class A's method is running"</code>
                <code class="plain">&lt;&lt; endl;</code></div>
        <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#125;</code></div>
        <div class="line number27 index26 alt2"><code class="plain">&#125;;</code></div>
        <div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number29 index28 alt2"><code class="library">class</code> <code
                        class="plain">B : </code><code class="library">public</code> <code class="plain">A &#123;</code>
        </div>
        <div class="line number30 index29 alt1"><code class="library">public</code><code class="plain">:</code>
        </div>
        <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">void</code> <code class="plain">print()</code></div>
        <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#123;</code></div>
        <div class="line number33 index32 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout &lt;&lt; </code><code class="string">"Class B's method is running"</code>
                <code class="plain">&lt;&lt; endl;</code></div>
        <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#125;</code></div>
        <div class="line number35 index34 alt2"><code class="plain">&#125;;</code></div>
        <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number37 index36 alt2"><code class="keywords">int</code> <code class="plain">main()</code>
        </div>
        <div class="line number38 index37 alt1"><code class="plain">&#123;</code></div>
        <div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">A a1;</code></div>
        <div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// method overloading (Compile-time polymorphism)</code></div>
        <div class="line number42 index41 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">a1.add(6, 5);</code></div>
        <div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// method overloading (Compile-time polymorphism)</code></div>
        <div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">a1.add(1, 2, 3);</code></div>
        <div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number47 index46 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">B b1;</code></div>
        <div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Method overriding (Run-time polymorphism)</code></div>
        <div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">b1.print();</code></div>
        <div class="line number51 index50 alt2"><code class="plain">&#125;</code></div>
</div>
<p><b>Difference between Inheritance and Polymorphism:</b></p>
<table style={{width:'90%'}}>
        <thead>
                <tr>
                        <th>S.NO</th>
                        <th>Inheritance</th>
                        <th>Polymorphism</th>
                </tr>
        </thead>
        <tbody>
                <tr>
                        <td>1.</td>
                        <td>Inheritance is one in which a new class is created (derived class) that inherits the
                                features from the already existing class(Base class).</td>
                        <td>Whereas polymorphism is that which can be defined in multiple forms.</td>
                </tr>
                <tr>
                        <td>2.</td>
                        <td>It is basically applied to classes.</td>
                        <td>Whereas it is basically applied to functions or methods.</td>
                </tr>
                <tr>
                        <td>3.</td>
                        <td>Inheritance supports the concept of reusability and reduces code length in object-oriented
                                programming.</td>
                        <td>Polymorphism allows the object to decide which form of the function to implement at
                                compile-time (overloading) as well as run-time (overriding).</td>
                </tr>
                <tr>
                        <td>4.</td>
                        <td>Inheritance can be single, hybrid, multiple, hierarchical and multilevel inheritance.</td>
                        <td>Whereas it can be compiled-time polymorphism (overload) as well as run-time polymorphism
                                (overriding).</td>
                </tr>
                <tr>
                        <td>5.</td>
                        <td>It is used in pattern designing.</td>
                        <td>While it is also used in pattern designing.</td>
                </tr>
        </tbody>
</table>
   </div>
    )
}

export default C_inh
